import * as types from "../types";

export const getCourses = ({ sort, page, perPage }) => {
  const request = {
    type: types.GET_COURSES,
    request: {
      url: "/courses",
      method: "GET",
      params: {
        "q[s]": sort,
        page,
        per_page: perPage
      }
    }
  };
  if (page && parseInt(page, 10) !== 1) {
    request.meta = {
      mutations: {
        // [types.GET_COURSES]: (prevData, newData) => {
        //   if (newData.meta.current_page <= prevData.meta.current_page) return newData;
        //   return { ...newData, data: prevData.data.concat(newData.data) };
        // }
      }
    };
  }
  return request;
};

export const getCourse = ({ courseId }) => {
  const request = {
    type: types.GET_COURSE,
    request: {
      url: `/courses/${courseId}`,
      method: "GET",
      params: {},
      meta: { mutations: {} }
    }
  };

  return request;
};

export const getSurvey = ({ courseId }) => {
  const request = {
    type: types.GET_SURVEY,
    request: {
      url: `/courses/${courseId}/survey`,
      method: "GET",
      params: {},
      meta: { mutations: {} }
    }
  };

  return request;
};

export const createSurveyAttempt = ({ surveyId, givenAnswers }) => {
  const request = {
    type: types.CREATE_SURVEY_ATTEMPT,
    request: {
      url: `/surveys/${surveyId}/survey_attempts`,
      method: "POST",
      data: {
        survey_attempt: {
          given_answers: givenAnswers
        }
      },
      meta: { mutations: {} }
    }
  };

  return request;
};
